import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import AdminNavigation from '../Inc/AdminNavigation';
import { notification, Input, Button, Icon, Divider, DatePicker, Spin, Pagination, Select, Modal, message, Row, Col, Checkbox, Form, InputNumber } from 'antd';
import * as actions from "../../actions/index";
import { compose } from "recompose";
import { history } from '../../container/History';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import warningAlert from '../Membership/warning-alert.png'
import moment from "moment"
import { withRouter } from "react-router-dom";
import InputMask from 'react-input-mask' 
import { useLocation } from "react-router-dom";
// import IntlCurrencyInput from "react-intl-currency-input"

const FormItem = Form.Item;
const Option = Select.Option;
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
}
class AddPromoCodePortal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ...props,
            preference: { "Formula": '', "Expressions": [] },
            quicksearch: {},
            formvalues: {},
            Home_State: '',
            AmountTypeId: [1858, 1859],
            productTypeId: [
                // {
                //     id : 3,
                //     desc : 'National Registration Fee'
                // },
                {
                    id : 6,
                    desc : '5year'
                },
                {
                    id : 7,
                    desc : 'Lifetime'
                },
                {
                    id: 9,
                    desc : '5year and/or Lifetime'
                }
                // {
                //     id : 8,
                //     desc : 'discount from 5 year'
                // },
                // {
                //     id : 9,
                //     desc : '5year and Lifetime'
                // },
            ],
            PromoValue: ['$', '%'],
            PromoAmountTypeId: '1858',
            getPrommoValue: '0',
            isShowCancelPopUp: false,
            isEditPromoCode: false,
            PromoValueInDecimal : undefined,
            IsValidPromocodeQuantity: true,
            CustomPromoCodeQuantityErrMsg: '',
            IsEditableEffectiveDate: true,
            IsEditableExpiryDate: true,
            
            IsValidEffectiveDate: true,
            CustomEffectiveDateErrMsg: '',
            IsValidExpiryDate: true,
            CustomExpiryDateErrMsg: '',
            IsFutureDate: false,
            CustomDateErrMsg: ''
        }
    }

    showCancelPopUp = () => {
        this.setState({
            isShowCancelPopUp: true
        })
    }
    hideCancelPopUp = () => {
        this.setState({
            isShowCancelPopUp: false
        })
    }

    states = () => {
        if (this.props.allstates) {
            let statesarray = this.props.allstates
            return statesarray.map((k, index) => {
                return (
                    <option key={k.id} value={k.name.split('-')[1]}>{k.short}</option>
                )
            })
        }
    }

    clearFields = () => {
        // this.props.form.resetFields()
        if (this.state.IsEditableEffectiveDate) {
            this.props.form.resetFields()

            this.setState({
                IsValidEffectiveDate: undefined,
                CustomEffectiveDateErrMsg: '',
                IsValidExpiryDate: undefined,
                CustomExpiryDateErrMsg: ''
            })
        //     this.props.form.setFieldsValue({
        //         promoID: '',
        //         orgGUID: 'F3A77C78-EE20-474E-9219' ,
        //         PromoCode: '' ,
        //         promoDes: '',
        //         AmountTypeId: '1858 - Dollar',
        //         PromoValue: '0',
        //         typeID: 3,
        //         programID: 4,
        //         quantityAllowed: '',
        //         quantityUsed: '0',
        //         effectiveDate: '',
        //         expiryDate: ''
        // });
        } else {
            this.props.form.setFieldsValue({
                promoID: this.state.promoCodeDetails.id,
                orgGUID: 'F3A77C78-EE20-474E-9219' ,
                PromoCode: this.state.promoCodeDetails.promoCode ,
                promoDes: '',
                AmountTypeId: this.state.promoCodeDetails.amountTypeId,
                PromoValue: this.state.promoCodeDetails.value,
                typeID: this.state.promoCodeDetails.productTypeId,
                programID: this.state.promoCodeDetails.productProgramId,
                quantityAllowed: 0,
                quantityUsed: this.state.promoCodeDetails.quantityUsed,
                effectiveDate: this.state.promoCodeDetails.effectiveDt,
                expiryDate: ''
        });
        }
             
    }

    Eaglestates = () => {
        if (this.props.allstates) {
            let statesarray = this.props.allstates
            return statesarray.map((k, index) => {
                return (
                    <option key={k.id} value={k.short}>{k.short}</option>
                )
            })
        }
    }

    handleSubmit = (e) => {

        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (this.state.IsEditableEffectiveDate) {
                this.checkEffectiveDate(values.effectiveDate)
            }
            if (this.state.IsEditableExpiryDate ) {
                this.checkExpiryDate(values.expiryDate)
            }

            if (!err && this.state.IsValidExpiryDate && this.state.IsValidEffectiveDate) {
               let amountTypeId = values.AmountTypeId.toString().includes('-') ? values.AmountTypeId.toString().split('-')[0] : values.AmountTypeId
                values.AmountTypeId = Number(amountTypeId)
                if (values.AmountTypeId == 1859) {
                    values.PromoValue = parseFloat(values.PromoValue) / 100;
                }
                const promoCodeSource = []
                
                 const orderSource = this.props.orderSourceLookup
                const BSAOrderType = this.props.BSA_OrderTypeLookup
                // According to sangeeta, core validation is that if orderSourceId is < or > 1, then bsaOrderTypeId should be null.
                if ( orderSource && BSAOrderType && !this.state.isEditPromoCode ) {
                     orderSource.map((source,i) => {
                        let bsaOrderTypeIdValue;
                        if(source.orderSourceId < 1 || source.orderSourceId > 1) {
                            bsaOrderTypeIdValue = null
                        }else{
                            bsaOrderTypeIdValue = BSAOrderType[i] && BSAOrderType[i].bsaOrderTypeId ? BSAOrderType[i].bsaOrderTypeId : null
                        }
                        
                        let payload = {
                            orderSourceId: source.orderSourceId,
                            bsaOrderTypeId: bsaOrderTypeIdValue
                        }
                            promoCodeSource.push(payload)
                    })
                    console.log("form validation success")
                } else if(!this.state.isEditPromoCode) {
                    Modal.error({
                        className: "ErrorModal",
                        title: 'Add Promo Code action Failed',
                        content: 'server error please try again after some time',
                    })

                }
                 
                this.state.isEditPromoCode ? 
                this.props.actions.updatePromoCode(values, this.state.promoCodeDetails.id, this.state.IsEditableEffectiveDate) :
                this.props.actions.AddPromoCodes(values, promoCodeSource) 
               
            }
        });

    }

    CheckTheDate = (value, i) => {

        console.log("CheckTheDate " + value) 
        var today = moment().format('MM/DD/YYYY'),
        enteredDate = value.split("/");

        enteredDate = new Date(enteredDate[2], enteredDate[1] - 1, enteredDate[0]).getTime();
        let isFuturedate =  moment(new Date(today)).isBefore(new Date(value));
        let isCurrentDate = moment(today).isSame(value);

        if (isFuturedate) {
            return this.setState({
                IsFutureDate: true,
                CustomDateErrMsg: 'Date Should not be in the future!'
            })
        } 
        if (isCurrentDate) {
            return this.setState({
                IsFutureDate: true,
                CustomDateErrMsg: 'Date Of Birth should not be as a current Date!'
            })
        }
        else {
            return this.setState({
                IsFutureDate: false,
                CustomDateErrMsg: ''
            })
        }

      }

      checkValidPromoCodeQuantity = (promoCodeQuantity) => {
        if (this.state.promoCodeDetails && this.state.isEditPromoCode ) {
            if(this.state.promoCodeDetails.quantityUsed < promoCodeQuantity){
                this.setState({
                    IsValidPromocodeQuantity: true,
                    CustomPromoCodeQuantityErrMsg: ''
                })
            }
            else {
                this.setState({
                    IsValidPromocodeQuantity: false,
                    CustomPromoCodeQuantityErrMsg: 'Promo Code Quantity allowed should be greater than quantity used'
                })
            }
        } 
      }


    componentDidMount = (e) => {

        const promoCode = this.props.location.state ? this.props.location.state.promoCode : undefined;

        this.props.actions.getOrderSourceLookups()
        this.props.actions.getBSAOrderTypeLookups()


        if (promoCode) {
            const promoCodeDetails = { ...promoCode }
            //     this.props.form.setFieldsValue({
            //         promoID: promoCode.id,
            //         orgGUID: promoCode.organizationGuid ,
            //         PromoCode: promoCode.promoCode ,
            //         promoDes: promoCode.promoDescription ,
            //         AmountTypeId: promoCode.amountTypeId ,
            //         PromoValue: promoCode.amountType == 'Dollar' ? "$" : '%',
            //         typeID: promoCode.productTypeId ,
            //         programID: promoCode.productProgramId ,
            //         quantityAllowed: promoCode.quantityAllowed ,
            //         quantityUsed: promoCode.quantityUsed ,
            //         effectiveDate: moment(promoCode.effectiveDt).format('MM-DD-YYYY'),
            //         expiryDate: moment(promoCode.expiryDt).format('MM-DD-YYYY')
            // });

            //Check decimal value
            promoCodeDetails.value = (promoCodeDetails.value - Math.floor(promoCodeDetails.value)) !== 0 ? Number(promoCodeDetails.value) * 100 : promoCodeDetails.value

            var today = new Date().getTime();

            // Check the promoCode's effective date is On or Past
            // Note: 
            // ****** If current date is on or past the listed ‘Effective Date’, the promotion is considered ‘active’; the effective date is not editable under this scenario.
            promoCodeDetails.expiryDt  = moment(promoCodeDetails.expiryDt).format('MM-DD-YYYY').replaceAll('-','/');
            promoCodeDetails.effectiveDt  = moment(promoCodeDetails.effectiveDt).format('MM-DD-YYYY').replaceAll('-','/');

            // let getEffectiveDate = moment(promoCodeDetails.effectiveDt, 'MM-DD-YYYY').format('MM-DD-YYYY');
            let getEffectiveDate = promoCodeDetails.effectiveDt;
            let currentDate = today;
            let IsEditableEffectiveDate = true;
            let IsEditableExpiryDate = true;

            if (moment(new Date(getEffectiveDate)).isBefore(currentDate) || moment(new Date(getEffectiveDate)).isSame(new Date(currentDate))) {
                IsEditableEffectiveDate = false // Since the effective date is already in the past or present, it cannot be changed.
            }
            else {
                this.checkEffectiveDate(getEffectiveDate) // we have to check the effective date whether is valid or not only when the effective date is editable. 
            }

            //Note:  If ExpiryDT is the current date or past date, the promotion code is considered active/ closed, and cannot be edited.
            let getExpiryDate = promoCodeDetails.expiryDt;
            // let getExpiryDate = moment(promoCodeDetails.expiryDt, 'MM-DD-YYYY').format('MM-DD-YYYY');

            if (moment(new Date(getExpiryDate)).isBefore(currentDate) || moment(new Date(getExpiryDate)).isSame(new Date(currentDate))) {
                IsEditableExpiryDate = false // Since the Expiry date is already in the past or present, it cannot be changed.
            }
                this.checkExpiryDate(getExpiryDate) // check whether the expiry date is valid or not


            this.setState({
                isEditPromoCode: true,
                promoCodeDetails,
                PromoAmountTypeId: promoCodeDetails.amountTypeId,
                getPrommoValue: promoCodeDetails.value,
                IsEditableEffectiveDate,
                IsEditableExpiryDate
            })

        }
        else {
            let getPrommoValue = '0', PromoAmountTypeId = '1858'
            this.setState({
                PromoAmountTypeId,
                getPrommoValue
            })
        }
    }

    checkEffectiveDate = (value) =>{
            let effectiveDate = value;
            let currentDate = new Date();
    
             if (moment(new Date(effectiveDate)).isValid() && moment(new Date(effectiveDate)).isAfter(new Date(currentDate))) {
                this.setState({
                    IsValidEffectiveDate: true,
                    CustomEffectiveDateErrMsg: ''
                })
            } 
            else if(!moment(new Date(effectiveDate)).isValid()){
                this.setState({
                    IsValidEffectiveDate: undefined,
                    CustomEffectiveDateErrMsg: ''
                })
            }
            else {
                this.setState({
                    IsValidEffectiveDate: false,
                    CustomEffectiveDateErrMsg: 'Effective date must be in the Future'
                })
            }
       
        }    

    checkExpiryDate = (value) =>{
        let expiryDate = value;
        let currentDate = new Date();

        
         if (moment(new Date(expiryDate)).isValid() && moment(new Date(expiryDate)).isAfter(new Date(currentDate))) {
            this.setState({
                IsValidExpiryDate: true,
                CustomExpiryDateErrMsg: ''
            })
        } 
        else if(!moment(new Date(expiryDate)).isValid()){
            this.setState({
                IsValidExpiryDate: undefined,
                CustomExpiryDateErrMsg: ''
            })
        }
        else {
            this.setState({
                IsValidExpiryDate: false,
                CustomExpiryDateErrMsg: 'Expiry date must be in the Future'
            })
        }
    }

    renderPromoAmountTypeId = () => {
        return this.state.AmountTypeId.map((type, index) => {
            return (
                <option key={type} value={type}>{type == '1858' ? `${type} - Dollar` : `${type} - Percentage`}</option>
            )
        })
    }
    renderProductTypeId = () => {
        return this.state.productTypeId.map((product, index) => {
            return (
                <option key={product.id} value={product.id}>{product.id} - {product.desc}</option>
            )
        })
    }

    renderPromoValue = () => {
        return this.state.PromoValue.map((type, index) => {
            return (
                <option key={index} value={type}>{type}</option>
            )
        })
    }
    handlePromoAmountTypeId = (value) => {
        console.log("value " + value);
      let  typeID = value == '1858' ? "00.00" : "0"
        this.props.form.setFieldsValue({'PromoValue': typeID})
        this.setState({
            PromoAmountTypeId: value
        })
    }

    renderPromoCodeButton = () => {
        let promoCodeButtonText = 'SAVE'
        if (this.state.isEditPromoCode) {
            promoCodeButtonText = this.props.updating_PromoCodes ? 'UPDATING' : 'UPDATE'
        } else {
            promoCodeButtonText = this.props.adding_PromoCodes ? 'SAVING' : 'SAVE' 
        }
        return  <Button type="primary width-100 save-change-btn" htmlType="submit" style={{ margin: '0px' }}>
        {/* <i class="fa fa-search margin-right-5" aria-hidden="true"></i> */}
        {promoCodeButtonText}
       </Button>
    }

    renderaddPromoCodeForm = () => {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        return <Form className='searchform alumni-ui' onSubmit={this.handleSubmit} >
            <div className='searchwidget ' type='flex' gutter={48}>
                <Row type='flex' align='middle' justify='center' >
                    <Col className="" span={8}>
                        <FormItem label='Promo ID'
                        >
                            {getFieldDecorator('promoID',{
                            initialValue: this.state.promoCodeDetails ? this.state.promoCodeDetails.id : '' 
                            })(
                                <Input disabled />
                            )}
                        </FormItem>
                    </Col>
                    <Col className="" span={8}>
                        <FormItem label='Organization GUID'
                        >
                            {getFieldDecorator('orgGUID', {
                                initialValue: this.state.promoCodeDetails ? this.state.promoCodeDetails.organizationGuid : 'F3A77C78-EE20-474E-9219'
                            })(
                                <Input disabled />
                            )}
                        </FormItem>
                    </Col>

                    <Col className="" span={8}>
                        <FormItem label='Promo Code'
                        >
                            {getFieldDecorator('PromoCode', {
                                initialValue: this.state.promoCodeDetails ? this.state.promoCodeDetails.promoCode : '',
                                rules: [{
                                    required: true, message: 'Enter the PromoCode'
                                },
                            {
                                pattern: /^[\S]+$/, message: 'White Space not allowed!'
                            }]
                            })(
                                <Input maxLength={50}  disabled= {!this.state.IsEditableEffectiveDate} />
                            )}
                        </FormItem>
                    </Col>
                </Row>


                <Row type='flex' align='middle' justify='center' >
                    <Col className="" span={8}>
                        <FormItem label='Promo Description'
                        >
                            {getFieldDecorator('promoDes', {
                                initialValue: this.state.promoCodeDetails ? this.state.promoCodeDetails.promoDescription : '',
                                rules: [{
                                    required: true , message: 'Enter the Promo Description'
                                }]
                            })(
                                <Input maxLength={250} />
                            )}
                        </FormItem>
                    </Col>

                    <Col className="" span={8}>
                        <FormItem label='Promo Amount 
                Look Up ID'>
                            {getFieldDecorator('AmountTypeId', {
                                initialValue: this.state.PromoAmountTypeId == '1858' ? `${this.state.PromoAmountTypeId} - Dollar` : `${this.state.PromoAmountTypeId} - Percentage`,
                                rules: [{ required: true, message: 'Select Promo Amount Look Up ID!' }], 
                            })(
                                <Select
                                     disabled= {!this.state.IsEditableEffectiveDate}
                                    onChange={this.handlePromoAmountTypeId}
                                    showSearch
                                    style={{ width: '100%' }}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {this.renderPromoAmountTypeId()}
                                </Select>
                            )}
                        </FormItem>
                    </Col>

                    <Col className="" span={8}>
                        <FormItem label='Promo Value'
                        >
                            {getFieldDecorator('PromoValue', {
                                initialValue: this.state.getPrommoValue ? this.state.getPrommoValue  : '',
                                rules: [{ required: true,  message: 'Enter the Promo Value!' }]
                            })(
                                this.state.PromoAmountTypeId == '1858' ? 
                                <InputNumber
                                     disabled= {!this.state.IsEditableEffectiveDate}
                                    className="PromoValueInput"
                                    defaultValue={0}
                                    max={99999999}
                                    formatter={value => `$ ${value}`.replaceAll(/^0+(?!$)/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replaceAll(/^0+(?!$)/g, '').replace(/\$\s?|(,*)/g, '')}
                                    onChange={() => { }}
                                />
                                    :
                                    <InputNumber
                                         disabled= {!this.state.IsEditableEffectiveDate}
                                        className="PromoValueInput"
                                        defaultValue={0}
                                        min={0}
                                        step={0}
                                        max={100}
                                        formatter={value =>  `${value.replaceAll(/^0+(?!$)/g, '')}%`}
                                        parser={value => value.replaceAll(/^0+(?!$)/g, '').replace( '%', '')}
                                        onChange={() => { }}
                                    />
                            )}
                        </FormItem>
                    </Col>
                </Row>

                <Row type='flex' align='middle' justify='center' >
                    <Col className="" span={8}>
                        <FormItem label='Promo Product Type ID'>
                            {getFieldDecorator('typeID', {
                                initialValue: this.state.promoCodeDetails ? this.state.promoCodeDetails.productTypeId :  "",
                                rules: [{ required: true, message: 'Select Promo Amount Look Up ID!' }], 
                            })(
                                <Select
                                    //  disabled= {}
                                    onChange={() => {}}
                                    showSearch
                                    style={{ width: '100%' }}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {this.renderProductTypeId()}
                                </Select>
                            )}
                        </FormItem>
                    </Col>

                    <Col className="" span={8}>
                        <FormItem label='Promo Product 
                Program ID'>
                            {getFieldDecorator('programID', {
                                initialValue: this.state.promoCodeDetails ? this.state.promoCodeDetails.productProgramId :  4
                            })(
                                <Input disabled />
                            )}
                        </FormItem>
                    </Col>

                    <Col className="" span={8}>
                        <FormItem 
                        label='Quantity Allowed'
                        validateStatus={!this.state.IsValidPromocodeQuantity ? "error"  : undefined}
                        hasFeedback
                        help={this.state.CustomPromoCodeQuantityErrMsg ? this.state.CustomPromoCodeQuantityErrMsg : undefined}
                        >
                            {getFieldDecorator('quantityAllowed', {
                                initialValue: this.state.promoCodeDetails ? this.state.promoCodeDetails.quantityAllowed :  '', 
                                rules: [
                                    { required: true, message: 'Enter the Quantity of Promo Code!' },
                                    { pattern: new RegExp("^[0-9]*$"), message: 'Enter only Numeric!' }
                                ],
                            })(

                                <InputNumber
                                    className="currencyInput"
                                    maxLength={7}
                                    formatter={value => {
                                        if(Number(value))
                                       return new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(value)
                                    }}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    onChange = {(value) => this.checkValidPromoCodeQuantity(value)}
                                />

                            )}
                        </FormItem>
                    </Col>
                </Row>

                <Row type='flex' align='middle' justify='center' >
                    <Col className="" span={8}>
                        <FormItem label='Quantity Used'
                        >
                            {getFieldDecorator('quantityUsed', {
                                initialValue: this.state.promoCodeDetails ? this.state.promoCodeDetails.quantityUsed :  0, 
                                // rules: [
                                //     { pattern: new RegExp("^[0-9]*$"), message: 'Enter only Numeric!' }
                                // ]
                            })(
                                <Input disabled />
                            )}
                        </FormItem>
                    </Col>

                    <Col className="" span={8}>
                        <FormItem label='Effective Date'
                            validateStatus={(!this.state.IsValidEffectiveDate && this.state.IsValidEffectiveDate != undefined )? "error"  : undefined}
                            hasFeedback
                            help={this.state.CustomEffectiveDateErrMsg ? this.state.CustomEffectiveDateErrMsg : undefined}
                        >
                            {getFieldDecorator('effectiveDate', {
                                initialValue: this.state.promoCodeDetails ? moment(this.state.promoCodeDetails.effectiveDt).format('MM/DD/YYYY') :  '', 
                                rules: [
                                    { required: true, message: 'Enter your Effective Date!' },
                                    {
                                        pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                        message: `Please enter correct format MM/DD/YYYY Pattern`
                                    }
                                ],
                            })(
                                // <DatePicker className='width-100' format="MM/DD/YYYY" />
                                <InputMask
                                    disabled= {!this.state.IsEditableEffectiveDate}
                                    mask="99/99/9999"
                                    placeholder='MM/DD/YYYY'
                                    alwaysShowMask
                                    maskChar={null}
                                    className="ant-input width-100"
                                    onChange={(e) => {this.checkEffectiveDate(e.target.value) }} 
                                    render={(ref, props) => (
                                        <Input  disabled= {!this.state.IsEditableEffectiveDate} />
                                    )}
                                />
                            )}
                        </FormItem>
                    </Col>

                    <Col className="" span={8}>
                        <FormItem label='Expiry Date'
                             validateStatus={(!this.state.IsValidExpiryDate && this.state.IsValidExpiryDate != undefined ) ? "error"  : undefined}
                             hasFeedback
                             help={this.state.CustomExpiryDateErrMsg ? this.state.CustomExpiryDateErrMsg : undefined}
                         >
                            {getFieldDecorator('expiryDate', {
                                initialValue: this.state.promoCodeDetails ? this.state.promoCodeDetails.expiryDt :  '', 
                                rules: [
                                    {
                                        required: true,
                                        message: 'Enter the Expiry date!'
                                    },
                                    {
                                        pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                        message: `Please enter correct format MM/DD/YYYY Pattern`
                                    }
                                ],
                            })(
                                // <DatePicker className='width-100' format="MM/DD/YYYY" />
                                <InputMask
                                    mask="99/99/9999"
                                    placeholder='MM/DD/YYYY'
                                    alwaysShowMask
                                    maskChar={null}
                                    className="ant-input width-100"
                                    onChange={(e) => {this.checkExpiryDate(e.target.value) }}
                                    render={(ref, props) => (
                                        <Input  />
                                    )}
                                />
                            )}
                        </FormItem>
                    </Col>
                </Row>

            </div>

            <div className="steps-action centered" style={{ width: '100%', marginTop: '25px' }}>
                <Row style={{ position: "unset", display: 'flex', alignItems: 'center' }} >
                    <Col xs={24} sm={24} md={9} lg={7} xl={7}  >
                        <FormItem>
                            <div className="pointer" style={{ color: '#1890ff', fontSize: '16px', textAlign: 'start' }} onClick={() => this.clearFields()}>
                                CLEAR FIELDS</div>

                        </FormItem>
                    </Col>
                    <Col className='xs-center sm-center ' xs={24} sm={24} md={7} lg={7} xl={7} offset={2}>
                        <FormItem>
                            <div className='step-container ' >
                                <Button type="primary" className='back-btn' style={{ fontSize: '16px', width: '100%', margin: '0px' }} onClick={() => { this.showCancelPopUp() }}>CANCEL</Button>
                            </div>
                        </FormItem>
                    </Col>
                    <Col className='xs-center sm-center' xs={24} sm={24} md={7} lg={7} xl={7} offset={1}>
                        <FormItem>
                           {this.renderPromoCodeButton()}
                        </FormItem>
                    </Col>
                </Row>
            </div>



        </Form>
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (<div>

            <LayoutHeader />

            <div style={{ margin: '20px 160px' }}>
                <div className='my-profile alumn-profile'>
                    <div className='widget'>
                        <div style={{ width: '1000px' }} >
                            <div className="text-result pointer" onClick={() => { history.push('/Promo-Code-Portal') }} >
                                <i class="fa fa-lg fa-long-arrow-left margin-right-5"></i> Back to: Promo Code Portal</div>
                        </div>
                    </div>
                    <div className='widget'>
                        <div className='widget-container'>
                            <div className="widget-header">
                                <div className='title'>
                                  {this.state.isEditPromoCode ? 'EDIT PROMO CODE' :  'CREATE PROMO CODE'}
                                </div> 
                            </div>


                            {this.renderaddPromoCodeForm()}

                            <Modal
                                centered
                                className='prompCodeCancelPopUp'
                                visible={this.state.isShowCancelPopUp}
                                onCancel={this.hideCancelPopUp}
                                onOk={() => {
                                    this.clearFields()
                                    this.hideCancelPopUp()
                                    history.push('/Promo-Code-Portal')
                                }}
                                okText= 'YES'
                                cancelText= "NO"
                            >
                                <div className="center">
                                    <div style={{paddingTop: '20px', fontSize: '14px'}}>
                                        <span style={{marginRight: '5px'}}>
                                            <img src={warningAlert} width="20px" height="20px" />
                                        </span>
                                        Do you want to cancel? </div>
                                    {/* <div> Please confirm the Scout’s Eagle Scout MemberID and try again.  Alternatively, you can reach out to your local council for further assistance.</div> */}


                                </div>
                            </Modal>

                        </div>
                    </div>
                </div>
            </div>
        </div>


        );
    }

}



function mapStateToProps(state) {
    return {
        getting_PromoCodes: state.getPromoCodeReducer.loading,
        PromoCodes: state.getPromoCodeReducer.promoCodes,
        get_PromoCodesErr: state.getPromoCodeReducer.err,

        adding_PromoCodes: state.addPromoCodeReducer.loading,
        PromoCode_Added: state.addPromoCodeReducer.response,
        Add_PromoCodeErr: state.addPromoCodeReducer.err,

        updating_PromoCodes: state.updatePromoCodeReducer.loading,
        PromoCode_Updated: state.updatePromoCodeReducer.response,
        update_PromoCodeErr: state.updatePromoCodeReducer.err,

        deleting_PromoCodes: state.deletePromoCodeReducer.loading,
        PromoCode_Deleted: state.deletePromoCodeReducer.response,
        Delete_PromoCodeErr: state.deletePromoCodeReducer.err,

        orderSourceLookup: state.getOrderSourceReducer.orderSourceLookup,
        BSA_OrderTypeLookup: state.getBSA_orderTypeReducer.BSA_OrderTypeLookup,

    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(Form.create()(AddPromoCodePortal));


// WEBPACK FOOTER //
// ./src/components/PromoCode/AddPromoCode.js